import CalendarAppConfig from './calendar/CalendarAppConfig';
//import ChatAppConfig from './chat/ChatAppConfig';

const appsConfigs = [
    CalendarAppConfig,
    //ChatAppConfig,
];

export default appsConfigs;